import { apiCall } from "@/common/api/ApiResult.model";
import { setQueryParams } from "@/utils/url";
import axios from "axios";

export const getConsentUrl = apiCall<void, string>("accounts", async () => {
  delete axios.defaults.headers.authorization;
  const res = await axios.get("/sso/ms/url");
  const url = setQueryParams(res.data, [
    ["redirect_uri", location.origin],
    ["state", "login"],
  ]);
  return {
    success: true,
    value: url,
  };
});

// #9908 , #9957
export const ssoLogin = apiCall<
  { code: string },
  { token: string; regionUrl: string }
>("accounts", async ({ code }) => {
  const res = await axios.post("/sso/ms", {
    code,
    redirectUri: location.origin,
  });
  const { token, appVersion = 2, regionUrl = "" } = res.data;
  return {
    success: true,
    value: {
      token,
      regionUrl,
    },
  };
});

export const getSingleUserConsentUrl = apiCall<void, string>(
  "accounts",
  async () => {
    delete axios.defaults.headers.authorization;
    const res = await axios.get("/single-user/sso/ms/url");
    const url = setQueryParams(res.data, [
      ["redirect_uri", location.origin],
      ["state", "login"],
    ]);
    return {
      success: true,
      value: url,
    };
  }
);

// #9908 , #9957
export const ssoSingleUserLogin = apiCall<
  { code: string },
  { token: string; regionUrl: string }
>("accounts", async ({ code }) => {
  const res = await axios.post("/single-user/sso/ms", {
    code,
    redirectUri: location.origin,
  });
  const { token, appVersion = 2, regionUrl = "" } = res.data;
  return {
    success: true,
    value: {
      token,
      regionUrl,
    },
  };
});
